(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7964],{

/***/ 35584:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour/[...slug]",
      function () {
        return __webpack_require__(42757);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_LoadingProgress; }
});

// UNUSED EXPORTS: LoadingProgress

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(24489);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(59016);
;// CONCATENATED MODULE: ./components/common/LoadingProgress/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  position: fixed;\n  bottom: 50px;\n  span {\n    color: #fff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  &.MuiLinearProgress-root {\n    height: 6px;\n    border-radius: 6px;\n    width: 60%;\n    box-shadow: 0px 0px 46px 6px rgba(255,255,255,0.8);\n  }\n  &.MuiLinearProgress-colorPrimary {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n  & .MuiLinearProgress-barColorPrimary {\n    background-color: #ffffff;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: block;\n  position: fixed;\n  width: 80px;\n  height: 80px;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n\n  div {\n    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    transform-origin: 40px 40px;\n\n    &:after {\n      content: " ";\n      display: block;\n      position: absolute;\n      width: 7px;\n      height: 7px;\n      border-radius: 50%;\n      background: #cef;\n      margin: -4px 0 0 -4px;\n    }\n\n    &:nth-child(1) {\n      animation-delay: -0.036s;\n\n      &:after {\n        top: 63px;\n        left: 63px;\n      }\n    }\n\n    &:nth-child(2) {\n      animation-delay: -0.072s;\n\n      &:after {\n        top: 68px;\n        left: 56px;\n      }\n    }\n\n    &:nth-child(3) {\n      animation-delay: -0.108s;\n\n      &:after {\n        top: 71px;\n        left: 48px;\n      }\n    }\n\n    &:nth-child(4) {\n      animation-delay: -0.144s;\n\n      &:after {\n        top: 72px;\n        left: 40px;\n      }\n    }\n\n    &:nth-child(5) {\n      animation-delay: -0.18s;\n\n      &:after {\n        top: 71px;\n        left: 32px;\n      }\n    }\n\n    &:nth-child(6) {\n      animation-delay: -0.216s;\n\n      &:after {\n        top: 68px;\n        left: 24px;\n      }\n    }\n\n    &:nth-child(7) {\n      animation-delay: -0.252s;\n\n      &:after {\n        top: 63px;\n        left: 17px;\n      }\n    }\n\n    &:nth-child(8) {\n      animation-delay: -0.288s;\n\n      &:after {\n        top: 56px;\n        left: 12px;\n      }\n    }\n  }\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Box",
    componentId: "sc-31e04f45-0"
})(_templateObject());
var style_LinearProgress = (0,styled_components_browser_esm/* default */.ZP)(LinearProgress/* default */.Z).withConfig({
    displayName: "style__LinearProgress",
    componentId: "sc-31e04f45-1"
})(_templateObject1());
var LoadingSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__LoadingSpinner",
    componentId: "sc-31e04f45-2"
})(_templateObject2());

// EXTERNAL MODULE: ./hooks/useLoadingProgress.tsx
var useLoadingProgress = __webpack_require__(29709);
;// CONCATENATED MODULE: ./components/common/LoadingProgress/index.tsx



var LoadingProgress = function(param) {
    var _showSpinner = param.showSpinner, showSpinner = _showSpinner === void 0 ? false : _showSpinner, _showBar = param.showBar, showBar = _showBar === void 0 ? true : _showBar;
    var ref = (0,useLoadingProgress/* useLoadingProgress */.O2)(), loadingProgress = ref.loadingProgress, loadingStep = ref.loadingStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: [
            loadingProgress > 0 && showBar && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                className: "d-flex flex-column align-items-center justify-content-center mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: "12px"
                        },
                        className: "mb-3",
                        children: loadingStep
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_LinearProgress, {
                        variant: "determinate",
                        value: typeof loadingProgress === "number" ? loadingProgress : 100
                    })
                ]
            }),
            (loadingProgress === 0 || showSpinner) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingSpinner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                ]
            })
        ]
    });
};
/* harmony default export */ var common_LoadingProgress = (LoadingProgress);


/***/ }),

/***/ 96311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable react/no-danger */ 

var PageHeader = function(param) {
    var slug = param.slug, title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, tourImage = param.tourImage, website = param.website, fbPixel = param.fbPixel, children = param.children, htmlCode = param.htmlCode, faviconUrl = param.faviconUrl, type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "fb:app_id",
                        content: "741048509750318"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: tourImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: tourImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "640"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "442"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://".concat(website, "/").concat(type, "/").concat(slug)
                    }),
                    faviconUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "".concat(faviconUrl)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            height: "1",
                            width: "1",
                            alt: "",
                            style: {
                                display: "none"
                            },
                            src: "https://www.facebook.com/tr?id=904257603695477&ev=PageView&noscript=1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                        id: "fb-connect",
                        strategy: "afterInteractive",
                        children: "\n        !function(f,b,e,v,n,t,s)\n              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n              n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n              n.queue=[];t=b.createElement(e);t.async=!0;\n              t.src=v;s=b.getElementsByTagName(e)[0];\n              s.parentNode.insertBefore(t,s)}(window, document,'script',\n              'https://connect.facebook.net/en_US/fbevents.js');\n              fbq('init', '904257603695477');\n              ".concat(fbPixel && fbPixel.length > 0 ? "fbq('init', ".concat(fbPixel, ");") : "", "\n              fbq('track', 'PageView');\n        ")
                    })
                ]
            }),
            htmlCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "htmlCode",
                dangerouslySetInnerHTML: {
                    __html: htmlCode
                }
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 42757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_common_PageHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96311);
/* harmony import */ var _components_common_LoadingProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3403);





var RegularTour = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(9650), __webpack_require__.e(4045), __webpack_require__.e(8466), __webpack_require__.e(7545), __webpack_require__.e(952), __webpack_require__.e(2115), __webpack_require__.e(1381), __webpack_require__.e(3329), __webpack_require__.e(1302), __webpack_require__.e(1387), __webpack_require__.e(5552), __webpack_require__.e(4331), __webpack_require__.e(2891), __webpack_require__.e(4362), __webpack_require__.e(5037), __webpack_require__.e(6562), __webpack_require__.e(817)]).then(__webpack_require__.bind(__webpack_require__, 74628));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74628)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_LoadingProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    },
    ssr: false
});
var getParams = function(slug) {
    // renderType
    // 0 : /tour/:mattterId
    // 1 : /token/:token
    // 2 : /tour/:slug/:videoType/:rule/:agentId/:chatToken
    // 2 : /tour/:slug/:videoType/:rule/:chatToken
    var matterId;
    var videoType;
    var rule;
    var agentId;
    var room;
    var renderType = 2;
    if ((slug === null || slug === void 0 ? void 0 : slug.length) === 1 || slug.length > 1 && slug[1] === "processOrder" || slug.length > 1 && slug[1] === "book" || slug.length > 1 && slug[1] === "login") {
        matterId = slug[0];
        renderType = 0;
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 4) {
        matterId = slug[0];
        videoType = slug[1];
        rule = slug[2];
        room = slug[3];
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 5) {
        matterId = slug[0];
        videoType = slug[1];
        rule = slug[2];
        agentId = slug[3];
        room = slug[4];
    } else {
        ;
    }
    return {
        matterId: matterId,
        videoType: videoType,
        rule: rule,
        agentId: agentId,
        room: room,
        renderType: renderType
    };
};
var IndexPage = function(param) {
    var data = param.data;
    var ref = JSON.parse(data), title = ref.title, description = ref.description, tourImage = ref.tourImage, website = ref.website, fbPixel = ref.fbPixel, faviconUrl = ref.faviconUrl, htmlCode = ref.htmlCode, tourData = ref.tourData, tags = ref.tags, matterTags = ref.matterTags;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = getParams(router.query.slug), matterId = ref1.matterId, renderType = ref1.renderType, videoType = ref1.videoType, rule = ref1.rule, agentId = ref1.agentId, room = ref1.room;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_PageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title,
        description: description,
        slug: matterId,
        tourImage: tourImage,
        website: website,
        fbPixel: fbPixel,
        faviconUrl: faviconUrl,
        htmlCode: htmlCode,
        type: "tour",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegularTour, {
            tourData: tourData,
            tags: tags,
            matterTags: matterTags,
            tourImage: tourImage,
            renderType: renderType,
            matterId: matterId,
            videoType: videoType,
            agentId: agentId || null,
            rule: rule,
            room: room,
            reactAws: "https://cdn.treedis.com",
            reactAppDomain: "https://api.treedis.com",
            reactAppMatterPort: "295ba0c0f04541318359a8e75af33043",
            reactPaypalClient: "AcYyCJIK1tv2azUW4suLJ7ekxPN-UiaM2JSRUdryWCpKMOYzH7yDhg073Ybp33832j3_feVg3NA9aAZc"
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3360,9774,2888,179], function() { return __webpack_exec__(35584); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);